/**
 * External Dependencies
 */
// import 'jquery';
// import Swiper from 'swiper';
import PerfectScrollbar from 'perfect-scrollbar';
import '@fancyapps/fancybox';
import {length} from "tailwindcss/lib/util/dataTypes";

(function ($) {
  $(document).ready(() => {

    const $menu_item_has_children = $('.nav-primary-desktop .menu-item-has-children');
    const $mobile_menu_trigger = $('.mobile_menu_trigger');
    const $sub_menu_wrap = $('.sub-menu-wrap');
    const $sub_menu_content = $('#sub_menu_content');

    // ---------------------------------
    // Main menu stuff
    // ---------------------------------
    if ($(window).width() < 1129) {
      let hoverTimeout;

      $mobile_menu_trigger.click(function(){
        $('#primary_navigation_mobile').toggleClass('is_open');
      });

      $menu_item_has_children.hover(function() {

        clearTimeout(hoverTimeout);

        $sub_menu_wrap.addClass('is_open');
        const $sub_menu_html = $(this).find('.sub-menu').first().html();

        $sub_menu_content.html($sub_menu_html);

      }, function(){

        hoverTimeout = setTimeout(function() {
          $sub_menu_wrap.removeClass('is_open');
        }, 500);

      });

      $('.menu-item.menu-item-has-children > a').on('click', function(e) {
        e.preventDefault();

        $(this).next('.sub-menu').slideToggle('fast');
      });

    }
    // ---------------------------------
    // Mobile sidebar
    // ---------------------------------

    const $mobile_sidebar_trigger = $('.mobile_sidebar_trigger');
    const $widget_h3 = $('.widget.woocommerce > h3');

    if ( window.innerWidth < 1000 ) {
      $widget_h3.on('click', function() {
        $(this).next('ul').slideToggle('fast');
      });
    }

    $mobile_sidebar_trigger.on('click', function() {
      const $sidebar = $('.custom-sidebar');

      $('body').toggleClass('no-scroll');
      $sidebar.toggleClass('hidden');
    });

    // ---------------------------------
    // Mobile accordion
    // ---------------------------------

    const mobile_tab_trigger = $('.tabs-mobile-title');

    mobile_tab_trigger.click(function(){
      const $this = $(this);

      $this.toggleClass('tabs-mobile-title--active');
      $this.next('.tabs-mobile-content').slideToggle('fast');
    });

    if ( $('.scroll_container').length ) {
      new PerfectScrollbar('.scroll_container');
    }

    // ---------------------------------
    // Swiper
    // ---------------------------------

    const swiper_container = document.querySelectorAll('.swiper-container');
    const container = document.querySelectorAll('.container');

    if ($('.swiper-container-frontpage').length) {
      new Swiper('.swiper-container-frontpage', {
        effect: 'slide',
        loop: false,
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
        autoplay: {
          delay: 6500,
          disableOnInteraction: false,
        },
      });
    }

    // Site Banner
    if ( $('.st-banner-swiper-container').length ) {

      const swiper = new Swiper('.st-banner-swiper-container', {
        loop: false,
        watchOverflow: true,
        autoplay: {
          delay: 5000,
        },

      });
    }

    if ( $('.swiper-container-srow').length ) {
      new Swiper('.swiper-container-srow', {
        slidesPerView: 'auto',
        centeredSlides: false,
        freeMode: true,
        watchOverflow: false,
        spaceBetween: 32,
        slidesOffsetAfter: ( container.length ? (window.innerWidth - container[0].offsetWidth) / 2 + 16 : 16 ),
      });
    }

    if ( $('.swiper-container-mrow').length ) {
      new Swiper('.swiper-container-mrow', {
        slidesPerView: 'auto',
        centeredSlides: false,
        freeMode: true,
        watchOverflow: false,
        spaceBetween: 32,
        slidesOffsetAfter: ( container.length ? (window.innerWidth - container[0].offsetWidth) / 2 + 16 : 16 ),
        breakpoints: {
          640: {
            slidesPerView: 2,
            slidesPerColumn: 2,
            spaceBetween: 10,
            freeMode: false,
          },
        },
      });
    }

    function offsetSwiperContainer() {
      let leftOffset = (window.innerWidth - container[0].offsetWidth) / 2 + 16;

      swiper_container.forEach((el) => {
        if ( ! el.classList.contains('swiper-container-no-offset') ) {
          if ( leftOffset > 17 ) {
            el.style.paddingLeft = `${leftOffset}px`;
          }
        }
      });
    }

    if ( container.length ) {
      offsetSwiperContainer();

      window.addEventListener('resize', () => {
        offsetSwiperContainer();
      });
    }

    jQuery( document.body ).on( 'removed_from_cart', () => {
      if ( $('.scroll_container').length ) {
        new PerfectScrollbar('.scroll_container');
      }
    } );

    // ---------------------------
    // Overlay
    // ---------------------------

    let body = document.body;
    let overlay = document.querySelector('.overlay');

    const $overlay = $('.overlay');
    const $body = $('body');

    $overlay.click(function(e){
      if ( $(e.target).hasClass('overlay') ) {
        $overlay.attr('aria-hidden', 'true');
        $body.removeClass('noscroll');
      }
    });

    $(document).on('click', '.toggle_minicart', function(){

      if ( $('.scroll_container').length ) {
        new PerfectScrollbar('.scroll_container');
      }

      setTimeout(() => overlay.scrollTop = 0, 1000);

      if ( $overlay.attr('aria-hidden') === 'true' ) {
        $overlay.attr('aria-hidden', 'false');
        $body.addClass('noscroll');
      } else {
        $overlay.attr('aria-hidden', 'true');
        $body.removeClass('noscroll');
      }
    });

    $(document).on('click', '.open_quick_cart', (e) => {
      e.preventDefault();

      if ( $('.scroll_container').length ) {
        new PerfectScrollbar('.scroll_container');
      }

      overlay.setAttribute('aria-hidden', false);
      body.classList.toggle('noscroll', true);
    } );
    // end overlay

    // Jei preke ideta i krepseli atidarom sidebar
    if ( $('.open_quick_cart_onload').length ) {
      overlay.setAttribute('aria-hidden', false);
      body.classList.toggle('noscroll', true);
    }

    // ---------------------------
    // Fancybox
    // ---------------------------

    $('.woocommerce-product-gallery .woocommerce-product-gallery__wrapper a').each(function () {
      $(this).attr('data-fancybox', 'product-gallery');
    });

    jQuery('[data-fancybox]').fancybox({
      loop: true,
      buttons : [
        'close',
      ],
      protect: true,
      transitionEffect : 'slide',
      hash: false,
    });

    // ---------------------------
    // Move checkout error notice
    // ---------------------------

    $( document.body ).on( 'checkout_error', function() {
      const err_html = $('.woocommerce-NoticeGroup-checkout').html();
      $('#checkout_error').html(err_html);
    });

    // ---------------------------
    // Cart events
    // ---------------------------

    $( document.body ).on( 'removed_from_cart', function() {
      if (!$('woocommerce-mini-cart__empty-message').length) {
        $('#cart_badget').addClass('hidden');
      }
    });

    // ---------------------------------------
    // Preventing auto input zoom for mobile
    // ---------------------------------------

    const disableIosTextFieldZoom = () => {
      const el = document.querySelector('meta[name=viewport]');

      if (el !== null) {
        let content = el.getAttribute('content');
        let re = /maximum-scale=[0-9.]+/g;

        if (re.test(content)) {
          content = content.replace(re, 'maximum-scale=1.0');
        } else {
          content = [content, 'maximum-scale=1.0'].join(', ')
        }

        el.setAttribute('content', content);
      }
    };

    // https://stackoverflow.com/questions/9038625/detect-if-device-is-ios/9039885#9039885
    const checkIsIOS = () =>
      /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;

    if (checkIsIOS()) {
      disableIosTextFieldZoom();
    }
  });


  // Newsletters Popup
  $(window).on('load',function(){

    if ($('.mc4wp-form').length) {

      if (!Cookies.get('newsletter_popup')) {
        $('body').addClass('is-reveal-open');
      }

      mc4wp.forms.on('success', function(form) {

        Cookies.set('newsletter_popup', 'newsletter', { expires: 365});

        $('body').addClass('f-nl-success');

        $('.mc4wp-success').find(function () {

          setInterval(function(){
            $('body').removeClass('is-reveal-open');
          }, 2500);
        })

      });

      $('#close').click(function () {

        Cookies.set('newsletter_popup', 'newsletter', { expires: 7 });
        $('body').removeClass('is-reveal-open');
      })

    }

  });
}(jQuery));
